
import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const getNewDoctorListApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}doctor/new-doctor-dtrf`,
        method: "get",
        data: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })

    return response

}

export default getNewDoctorListApi
